import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import CancelButton from '../atoms/CancelButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({ openDelete, updateOpenDelete, cancelAction, deleteAction }) => {
    return (
      <Dialog
        open={openDelete}
        onClose={() => {
          updateOpenDelete(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            この店舗のパスワードをリセットしますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <Button color="primary" onClick={deleteAction}>
            決定
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
